<template>
  <div class="home1 full-height" style="position: relative;">
    <!-- default-banner linear-main3  -->
    <!-- class="bg-main"
      style="height: 224px" 原先标头盒子的样式-->

    <div class="swipe_hie">
      <van-swipe
        :autoplay="5000"
      >
        <van-swipe-item
          v-for="(advertise, index_) in images"
          :key="index_"
        >
          <van-image
            height="175px"
            width="100%"
            lazy-load
            :src="advertise.pictureUrl"
            @click="goAdvertiseLink(advertise.advertiseLink)"
            class="full-width"
          />
        </van-swipe-item>
      </van-swipe>
      <ld-statusbar />
      &nbsp;
    </div>
    <div
      class="full-width"
      style="position: absolute; padding: 0px 10px;pointer-events: none;"
    >
      <!-- <van-row
        class="white list"
        type="flex"
        align="center"
      >
        <van-col
          span="18"
          class="logo font18"
        > -->
      <!-- {{ loginConfig.pageName }} -->
      <!-- </van-col> -->
      <!-- <van-col span="2"> -->
      <!-- <div
            v-if="loginConfig.by4 == 'QHHK'"
            class="inline-block white pointerEvents"
            @click="$emit('changeHome')"
          >
            <span
              style="
                display: inline-block;
                padding: 0px 2px;
                border: 1px solid #fff;
                border-radius: 3px;
              "
            >
              <van-icon
                name="exchange"
                class="font18"
              />
            </span>
            <div class="font12">
              版本
            </div>
          </div> -->
      <!-- &nbsp;
        </van-col> -->

      <!-- <van-col span="4">
          <div
            class="server text-center pointerEvents"
            @click="$router.push({ path: '/service' })"
          >

            <van-icon
              class="font22"
              name="service"
            />
            <div class="font12">
              {{ $t("A022", "专属客服") }}
            </div>
          </div>
        </van-col> -->
      <!-- </van-row> -->

      <div class="defaulthomewrapper">
        <mescroll-vue
          ref="mescroll"
          :down="{ use: false }"
        >
          <!-- 下午好加名字 -->
          <!-- <div class="white box">
            <div class="list font18">
              {{ getTimeState() }}好
              <span v-if="userInfo.empInf || (userInfo.empInfo&&userInfo.empInfo.empName)">
                ，
              </span>
              {{
                userInfo.empInfo && userInfo.empInfo.empName
              }}
            </div>
            <div class="list" v-if="userInfo.vipCorp || (userInfo.vipCorp&&userInfo.vipCorp.shortname)">
              欢迎您进入{{ userInfo.vipCorp && userInfo.vipCorp.shortname }}
            </div>
          </div> -->
          <!-- pointerEvents:auto :处理banner图覆盖问题 -->
          <div class="pointerEvents">

            <div>
              <van-tabs v-model="active" @change="switching" >
                <div v-for="(item, index) in menuList" :key="index">
                  <van-tab v-if="item.openDiasble" :title="$t(item.title)" >
                    <div class="tabsbox" @click="tabsbox()">
                      <!-- <div v-if="item.PRO_TYPE=='10901'">
                        <TkQuerysam></TkQuerysam>
                      </div> -->
                      <component :is="item.componen" :leisure="business"/>
                    </div>
                    <!-- <TkQuerysam></TkQuerysam> -->
                  </van-tab>
                </div>
              </van-tabs>
            </div>
            <!--专属客服可拖  -->
            <dragged :top="top">
              <div class="customer linear-main1"
                   @touchstart="touchstartit($event)"
                   @touchend="touchendit($event)"
                   @click="$router.push({ path: '/service' })"
              >
                <div class="radiu_s">
                  <van-icon class="font22" name="service"/>
                </div>

                <span class="font12_fff" v-if="spanshow">  {{ $t("A022", "专属客服") }}</span>
              </div>
            </dragged>

            <div
              class="list"
              v-if="loginNotices && loginNotices.length"
            >
              <van-notice-bar
                class="full-width round-md shadow"
                background="#ffffff"
                mode="link"
                color="#707070"
                @click="$router.push({ path: '/noticeList' })"
              >
                <van-image
                  width="24"
                  style="padding-right: 6px"
                  slot="left-icon"
                  :src="bullhorn_icon"
                />
                <span
                  v-for="notice in loginNotices"
                  :key="notice.id"
                >
                  {{ notice.content }}
                </span>
              </van-notice-bar>
            </div>

            <!-- :class="[item.openDiasble ? 'menu-disabled' : '']" -->
            <!-- <van-row
              type="flex"
              gutter="10"
            >
              <van-col
                span="12"
                v-for="tab in menuList"
                :key="tab.link"
                class="list"
                v-if="tab.openDiasble"
              >
                <div class="container bg-white round-md shadow">
                  <van-cell @click="to(tab)">
                    <van-image
                      v-lazy
                      width="42"
                      height="42"
                      :src="tab.img"
                    />
                    <div class="font16 font-md">
                      {{ $t(tab.title) }}
                    </div>
                    <div class="gray">
                      {{ tab.label }}
                    </div>
                  </van-cell>
                </div>
              </van-col>
            </van-row> -->

            <!-- Menu -->
            <!-- 行程列表盒子 ------------------------------------------------------------------------------------------------>
            <!-- <div class="list round-md">
              <van-cell
                class="round-md bg-image"
                v-show="orderList.length == 0"
                style="height: 110px"
                center
              >
                <div style="padding: 10px">
                  <div class="font20 font-bold green">
                    暂无行程
                  </div>
                  <div class="gray">
                    暂无日程，前往预订
                  </div>
                </div>
                <div slot="right-icon">
                  <img
                    src="~Components/Dynamic/default/images/schedule-empty.png"
                    style="width: 136px; margin-top: 29px"
                  >
                </div>
              </van-cell>
              <van-swipe
                class="shadow vanSwipe"
                :autoplay="0"
                height="110"
                v-show="true"
              >
                <van-swipe-item
                  v-for="(item, index) in orderList"
                  :key="index"
                  @click="$router.push({ path: '/schedule' })"
                >
                  <SchedulePanel
                    :data="item"
                    :order-type="item.orderType"
                  />
                </van-swipe-item>
              </van-swipe>
            </div> -->
            <!--  下面5个圆圈选项---------------------->
            <div
              class="list"
              v-show="modular"
            >
              <van-cell class="round-md shadow">
                <van-row
                  type="flex"
                  align="center"
                  class="text-center"
                >
                  <van-col
                    v-for="(item, index) in menuList_other"
                    :span="item.span"
                    :key="index"
                    @click="to(item)"
                    v-if="item.openDiasble"
                  >
                    <van-image
                      lazy-load
                      width="30"
                      :src="item.img"
                      class="full-width"
                    />
                    <div
                      class="font12 font-md"
                      style="line-height: 12px"
                    >
                      {{ item.title }}
                    </div>
                  </van-col>
                </van-row>
              </van-cell>
            </div>
          </div>
        </mescroll-vue>
      </div>

    </div>
  </div>
</template>

<script>
import {
  Tabbar,
  TabbarItem,
  Popup,
  Grid,
  GridItem,
  Icon,
  NoticeBar,
  Image as VanImage,
  Cell,
  Swipe,
  SwipeItem,
  Tabs, Tab,FloatingBubble

} from 'vant'
import MescrollVue from 'mescroll.js/mescroll.vue'
import { getTimeState } from 'Utils/dateUtil'
import SchedulePanel from 'Views/Home/schedule/components/panel'
import ldStatusbar from 'Common/ldStatusbar'

import menu_tk from 'Components/Dynamic/default/images/menu/tk.png'
import menu_ht from 'Components/Dynamic/default/images/menu/ht.png'
import menu_tr from 'Components/Dynamic/default/images/menu/tr.png'
import menu_car from 'Components/Dynamic/default/images/menu/car.png'
import menu_visa from 'Components/Dynamic/default/images/menu/visa.png'

import menu_checkIn from 'Components/Dynamic/default/images/menu/checkIn.png'
import menu_fastCheck from 'Components/Dynamic/default/images/menu/fastCheck.png'
import menu_guestPass from 'Components/Dynamic/default/images/menu/guestPass.png'
import menu_restRoom from 'Components/Dynamic/default/images/menu/restRoom.png'

import menu_strategy from 'Assets/images/home/menu_strategy.png'
import menu_discount from 'Assets/images/home/menu_discount.png'
import menu_freebus from 'Assets/images/home/menu_freebus.png'
import menu_contracthotel from 'Assets/images/home/menu_contracthotel.png'
import menu_policy from 'Assets/images/home/menu_policy.png'

import bullhorn_icon from 'Components/Dynamic/default/images/home/bullhorn.png'
import homeMixin from './homeMixin'
import TkQuerysam from 'Components/Dynamic/default/homemodule/tkQuerysam/index.vue' //用车
import Htquerysma from 'Components/Dynamic/default/homemodule/htQuerysma/index.vue' //酒店
import TrQuerysma from 'Components/Dynamic/default/homemodule/trQuerysma/index.vue' //火车
import carQuerysma from 'Components/Dynamic/default/homemodule/carQuerysam/index.vue' //火车
import dragged from 'Components/Dynamic/default/homemodule/components/dragged.vue' //拖
import ticket2 from 'Assets/images/banner/ticket2.jpg'
import train2 from 'Assets/images/banner/train2.jpg'
import {getParameter} from 'Utils/publicApi'
import aes from 'Utils/aes'
import { parseQueryString } from 'Utils/string'
import { getDeviceInfo, isH5 } from 'CommonUtils/plus.js'






export default {
  name: 'Home',
  mixins: [homeMixin],
  props: {
    menulist: {
      type: Array,
      default: function () {
        return []
      },
    },
  },
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Popup.name]: Popup,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    [VanImage.name]: VanImage,
    [Cell.name]: Cell,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    MescrollVue,
    ldStatusbar,
    SchedulePanel,
    dragged,
    carQuerysma,
    TkQuerysam,
    Htquerysma,
    TrQuerysma,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,

  },
  data () {
    return {
      modular: true,
      bullhorn_icon,
      menuList: [
        {
          link: '/tk/tkQuery',
          title: 'A008', //机票
          img: menu_tk,
          label: '低价机票，舒适出行',
          PRO_TYPE: 10901,
          openDiasble: false,
          componen:'TkQuerysam'

        },
        {
          link: '/ht/htQuery',
          title: 'A009', //酒店
          img: menu_ht,
          label: '尊贵入住，商旅独享',
          PRO_TYPE: 10903,
          openDiasble: false,
          componen:'Htquerysma'

        },
        {
          link: '/tr/trQuery',
          title: 'A010', //火车票
          img: menu_tr,
          label: '舒适高铁，在线选座',
          PRO_TYPE: 10904,
          openDiasble: false,
          componen:'TrQuerysma'

        },
        {
          link: '/car/carQuery',
          title: 'A011', //用车
          img: menu_car,
          label: '晚点必等，安心出行',
          PRO_TYPE: 10906,
          openDiasble: false,
          componen:'carQuerysma'

        },
      ],
      menuList_minor: [
        {
          link: '/tkIntel/policy',
          title: 'A019', //'国际特惠',
          img: menu_strategy,
          openDiasble: false

        },
        {
          link: '/tk/policy',
          title: 'A020', //'协议直减',
          img: menu_discount,
          openDiasble: false

        },
        {
          link: '/tk/airportBus',
          title: 'Q016', //机场大巴
          img: menu_freebus,
          openDiasble: false

        },
        {
          link: '/ht/htQuery/htSignList',
          title: 'A021', //'协议酒店',
          img: menu_contracthotel,
          openDiasble: false

        },
        {
          link: '/tk/strategy',
          title: 'Q007', //机场攻略
          img: menu_policy,
          openDiasble: false

        },
      ],
      menuList_other: [
        {
          link: '/visa',
          title: '签证', //签证
          img: menu_visa,
          label: '全国受理，一对一辅导',
          span: 4,
          PRO_TYPE: 10913,
          openDiasble: false

        },
        {
          link: '/checkIn',
          title: '优先值机',
          img: menu_checkIn,
          span: 5,
          PRO_TYPE: 10916,
          openDiasble: false

        },
        {
          link: '/guestPass',
          title: '要客通',
          img: menu_guestPass,
          span: 5,
          PRO_TYPE: 10917,
          openDiasble: false

        },
        {
          link: '/fastCheck',
          title: '快速安检',
          img: menu_fastCheck,
          span: 5,
          PRO_TYPE: 10915,
          openDiasble: false

        },
        {
          link: '/restRoom',
          title: '休息室',
          img: menu_restRoom,
          span: 5,
          PRO_TYPE: 10914,
          openDiasble: false

        },
        // {
        // 	link: '/home',
        // 	title: '敬请期待',
        // 	icon: 'iconweibiaoti-24',
        // 	color:'#248aff',
        // 	disabled: true
        // }
      ],
      orderList: [],
      images: [ ],
      active:'',
      // TkQuerysam 用车
      comName:'TkQuerysam',
      top:260,
      right:true,
      spanshow:false,
      business:false, // 隐藏因公因私
    }
  },
  async created () {
    if (this.menulist.length) {
      this.menuList = this.menulist
    }
    await this.getAuthorizationPnos()
    this.genMenu([...this.menuList])
    this.genMenu([...this.menuList_other])
    this.menuList=this.menuList.filter((item)=>{
      return item.openDiasble==true
    })
    this.init()
    this.OnMap()
    let data1= await  getParameter('20036') //隐藏因公因私
    data1.value1==1 ? this.business=false :this.business=true

    this.singlesign()  // 单点登录

  },
  mounted () {
    this.getOrderList()
    this.getPullData()

  },

  methods: {
    init() {
      let newA = this.menuList_other.filter(function (item, index) { //index是索引
        return item.openDiasble == true
      })
      console.log('newA', newA)
      if (newA != '') {
        this.modular = true
      } else {
        this.modular = false
      }
    },
    async singlesign() {
      const queryObj = parseQueryString(window.location.href)
      if (queryObj.channelParam) {
        var channelParam = JSON.parse(aes.decrypt(decodeURIComponent(queryObj.channelParam), 'kl1ls9hie3uq5zxm'))
        let params = {
          account: '', //不知
          compId: channelParam.companyId,
          corpId: channelParam.corpId,
          loginName: channelParam.loginName, //手机号
          deviceShortname: getDeviceInfo().deviceShortname, //设置型号
          deviceId: getDeviceInfo().deviceId, //设备标识
          autologinType: channelParam.loginType, //(integer, optional): 登陆方式,1-自动登录2-手动登录
          loginWay: 4,// 1-密码登录 2-验证码 3-注册4-第三方跳转
          password: channelParam.password,// 密码
          openId: '',
        }
        this.$store.dispatch('login', params)
      }

    },

    getTimeState,
    getPullData() {
      let data = {
        requestFrom: 2,
      }
      this.$api['common/pullData'](data).then((res) => {
        if (res.data) {
          const {data} = res
          let pictureUrlList = []
          data.forEach((element) => {
            let advertise = {
              pictureUrl: element.pictureUrl,
              advertiseLink: element.advertiseLink,
            }
            pictureUrlList.push(advertise)
          })

          // this.images = pictureUrlList

          this.images = [{pictureUrl: ticket2,}, {pictureUrl: train2,}]

        }
      })
    },
    goAdvertiseLink(path) {
      if (path) {
        location.href = path
      }
    },
    getOrderList() {
      this.$api['tkOrder/getScheduleOrder']()
        .then((res) => {
          var cache = res.data || {}
          this.orderList = cache.list || []
          if (this.orderList.length === 0) {
            this.getAdv()
          }
        })
        .catch(() => {
        })
    },
    // 获取广告图
    getAdv() {
    },
    switching($event) {
      console.log('点击标签页', $event)
      console.log("active", this.active)
      this.comName = this.menuList[this.active].componen
    },
    handleTabClick(dd) {
      console.log('2222', dd)
    },
    tabsbox() {
      let userInfo = localStorage.getItem('userInfo')
      if (!userInfo) {
        this.$router.push({path: '/login'})
      }
    },
    touchstartit(e) {
      this.spanshow = true
    },
    touchendit(e) {
      this.spanshow = false
    },
    OnMap() {
      let userInfo = JSON.parse(localStorage.getItem('userInfo'))
      let loginConfig = this.$store.state.app.loginConfig
      if (userInfo || loginConfig) {
        let params
        if (userInfo) {
          params = {
            corpId: userInfo.empInfo.corpId,
            compId: userInfo.vipCorp.companySuper,
          }
        } else {
          params = {compId: loginConfig.compaySuper}
        }
        this.$api['tkOrder/findInfo'](params)
          .then((resp) => {
            if (resp.data && resp.data.imgUrl != '') {
              if (resp.data.imgUrl.includes('#')) {
                let ulr = resp.data.imgUrl.split("#")
                ulr = ulr.map((item,) => {
                  return {pictureUrl: item,};
                });
                this.images = ulr
              } else {
                this.images = [{pictureUrl: resp.data.imgUrl}];
              }
            } else {
              this.images = [{pictureUrl: ticket2,}, {pictureUrl: train2,}];
            }
            //  console.log('res论播图',res)
          })
          .catch(() => {
          })
      } else {
        this.images = [{pictureUrl: ticket2,}, {pictureUrl: train2,}];
      }
    },
  },
}
</script>

<style lang="less" scoped>
@deep: ~">>>";

.pointerEvents {
  pointer-events: auto;
}

.box {
  padding: 0 10px;
}

.home1 {
  //   position: relative;
  //   padding: 10px;
  //   background-size: cover;
  //   background-position-y: initial;

  .logo {
    img {
      width: 57px;
    }
  }

  .list {
    padding-bottom: 8px;
    padding-top: 10px;
  }

  .container {
    padding: 4px;
  }

  .defaulthomewrapper {
    // height: calc(100vh - 156px);
    overflow: hidden;
    // min-height: 554px;
  }

  .vanSwipe {
    width: calc(100vw - 20px);
    height: 115px;
  }

  .shadow {
    box-shadow: 0 3px 3px 1px rgba(0, 0, 0, 8%);
  }
}

@{deep}.van-swipe__indicators {
  bottom: 7px;
}

@{deep}.van-swipe__indicator:not(.van-swipe__indicator--active) {
  border: 1px solid;
}

.default-banner {
  background-image: url("~Components/Dynamic/default/images/bg.png");
}
.tabsbox{
  // height: 900px;
    background-color: #fff;
    padding-top: 8px
}
.pointerEvents  /deep/  .van-tab.van-tab--active {
    // height: 26px;
    background-color: #fff;
    // margin: 0px 5px 0 5px;
    // border-radius: 3px;
    // font-size: 16px;
    // font-weight: 600;
  }
// .van-tabls {
//   background-color: rgb(241 244 248);
// }
/deep/ .van-tabs__nav--line {
  padding-bottom: 10px;
  // font-size: 16px;
}
// /deep/ .van-tabs:first-child .van-tab .van-tab__text--ellipsis {
//     font-size: 16px; /* 设置字体大小为16像素 */
//     font-weight: 700;
// }
// /deep/ .van-tabs--card .van-tab:first-child .van-tab--active{

//     font-size: 17px;
//     font-weight: 700;
// }
.swipe_hie{
  height: 22%;
}
/deep/ .van-swipe__indicators{
  bottom:35px;
}
// /deep/ .supenpopup{
//   background-color: #3333;
//     position: absolute;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     border-radius: 16px;
// }
.customer{
    display: flex;
    justify-content: center;
    align-items: center;


    height: 37px;
    // background-color: pink;
    border-radius: 40px 0 0 40px;
    padding: 2px;
    position: absolute;
    /* top: 10px; */
    // bottom: 241px;
    right: 0px;


}
.radiu_s{
    height: 93%;
    width: 33px;
    background-color:#fff;
    border-radius: 59%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.font12_fff{
    font-size: 12px;
    white-space: nowrap;
    color: #fff;
}
</style>
